import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { get, isEmpty } from 'lodash'

import AsOfDate from '../AsOfDate'
import ScrollingTable from '../Tables/ScrollingTable'
import { formatPercentOneDecimal } from '../../utils/functions'
import { NO_DATA_MESSAGE } from '../../utils/constants'

// Default columns
const COLUMNS = [
  {
    Header: 'Company Name [Ticker]',
    id: 'companyName',
    accessor: 'companyName',
  },
  {
    Header: '% of Net Assets',
    id: 'percentNetAssets',
    accessor: 'percentNetAssets',
  },
]

class TopHoldingsEquity extends PureComponent {
  getColumns() {
    const { data } = this.props
    const updatedColumns = [...COLUMNS]

    // If index_ticker is present, change the second column header to "Weight %"
    if (data?.index_ticker) {
      updatedColumns[1] = {
        ...updatedColumns[1],
        Header: 'Weight %',
      }
    }

    return updatedColumns
  }

  getTableData(topHoldings) {
    return topHoldings.map((holding) => {
      const weight = parseFloat(holding.weight)
      const validWeight = isNaN(weight) ? 0 : weight
      return {
        companyName:
          holding.securityName +
          (holding.ticker !== ' ' ? `[${holding.ticker}]` : ''),
        percentNetAssets: formatPercentOneDecimal(validWeight),
      }
    })
  }

  getFooterData(data, topHoldings) {
    const label = data?.index_ticker
      ? '% of Total Constituents:'
      : '% of Total Holdings:'

    const totalPercent = topHoldings
      .reduce((total, item) => {
        const weight = parseFloat(item.weight)
        const validWeight = isNaN(weight) ? 0 : weight
        return total + Math.round(validWeight * 1000) / 10
      }, 0)
      .toFixed(1)

    return [
      {
        companyName: label,
        percentNetAssets: `${totalPercent}%`,
      },
    ]
  }

  getOptions() {
    const { presentation } = this.props
    return {
      presentation,
      stripedTable: true,
    }
  }

  render() {
    const { data } = this.props
    const topHoldings =
      data?.topHoldings || data?.dailyHoldings || data?.holdings || []

    if (isEmpty(topHoldings)) {
      return <p>{NO_DATA_MESSAGE}</p>
    }

    const asOfDate = get(topHoldings, '[0].calendar.date')
    const columns = this.getColumns()
    const tableData = this.getTableData(topHoldings)
    const footerData = this.getFooterData(data, topHoldings)
    const options = this.getOptions()

    return (
      <>
        <AsOfDate date={asOfDate} />
        <ScrollingTable
          columns={columns}
          data={tableData}
          footerData={footerData}
          options={options}
          otherClassName="topholdings-equity"
        />
      </>
    )
  }
}

TopHoldingsEquity.propTypes = {
  data: PropTypes.shape({
    topHoldings: PropTypes.array,
    dailyHoldings: PropTypes.array,
    holdings: PropTypes.array,
    index_ticker: PropTypes.string,
  }),
  presentation: PropTypes.object,
}

export default TopHoldingsEquity
